import type { DehydratedState } from "@tanstack/react-query";
import { useLoaderData } from "react-router";

/**
 * The route's dehydrated Query state, tolerating exit renders: the
 * transition layer keeps an unmounting route rendered after React Router
 * has dropped its loader data, so this read must survive undefined.
 */
export function useDehydratedState(): DehydratedState | null | undefined {
  const data = useLoaderData<{
    dehydratedState: DehydratedState | null;
  }>() as { dehydratedState: DehydratedState | null } | undefined;
  return data?.dehydratedState;
}
